import HotelList from "../components/HotelList";

export default function Hotels() {
    return (
        <div>
            <HotelList showSidebar={true} showBanner={true} showHeading={false} />
        </div>
    );
}